import { render, staticRenderFns } from "./ExerciseListClient.vue?vue&type=template&id=cc5517a2&scoped=true"
import script from "./ExerciseListClient.vue?vue&type=script&lang=js"
export * from "./ExerciseListClient.vue?vue&type=script&lang=js"
import style0 from "./ExerciseListClient.vue?vue&type=style&index=0&id=cc5517a2&prod&lang=css"
import style1 from "./ExerciseListClient.vue?vue&type=style&index=1&id=cc5517a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5517a2",
  null
  
)

export default component.exports